import React from "react";
import MoreButton from "./MoreButton";

const FeatureDatabricksHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="pb-16 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                <div className="relative mx-auto flex max-w-7xl flex-col justify-between gap-[50px] px-5 sm:static sm:flex-row sm:px-10 lg:items-start lg:gap-4 lg:px-8">
                    <div className="sm:max-w-lg">
                        <h1 className="text-balance font-bold tracking-tight text-gray-900 text-h1">
                            데이터브릭스{" "}
                            <br />
                            데이터 &amp; AI 혁신
                        </h1>
                        <p className="mt-3 font-bold text-brand text-h3 sm:mt-4">
                            데이터 레이크하우스, Photon 엔진,
                            <br className="hidden sm:block" />
                            Agent Bricks, UNITY CATALOG, DELTA LAKE
                        </p>
                        <p className="mt-3 text-gray-500 text-body sm:mt-4">
                            많은 기업이 Databricks를 통해 데이터, 분석, 생성형 AI
                            기술을 하나로 통합하며 조직 전체의 데이터 지능을
                            높이고 혁신을 실현하고 있습니다. 지금 바로 글로벌
                            데이터 인텔리전스 플랫폼을 경험해보세요.
                        </p>
                        <MoreButton className="mt-5 sm:mt-6" />
                    </div>

                    <div className="w-full lg:max-w-[624px]">
                        <img
                            className="h-auto w-full object-contain"
                            src="/img/databricks/hero.png"
                            alt="Databricks Data Intelligence Engine"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureDatabricksHead;
